import createLucideIcon from '../createLucideIcon';

const Merge = createLucideIcon('Merge', [
  ['path', { d: 'm8 6 4-4 4 4', key: 'ybng9g' }],
  ['path', { d: 'M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22', key: '1hyw0i' }],
  ['path', { d: 'm20 22-5-5', key: '1m27yz' }],
]);

export default Merge;
